import React from 'react';

import GoogleDriveIcon from '@atlaskit/legacy-custom-icons/google-drive-icon';
import LoomIcon from '@atlaskit/legacy-custom-icons/loom-icon';
import MicrosoftSharepointIcon from '@atlaskit/legacy-custom-icons/microsoft-sharepoint-icon';
import SlackIcon from '@atlaskit/legacy-custom-icons/slack-icon-ai-mate';
import { AtlassianIcon, ConfluenceIcon, JiraIcon } from '@atlaskit/logo';

export const formatKnowledgeSourceLabel = (source: string) =>
	source === 'atlas'
		? 'Atlassian Home'
		: source
				.replace(/[_-]/g, ' ') // Replace underscores and dashes with spaces
				.split(' ')
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
				.join(' ');

export const iconMapper: Record<string, JSX.Element> = {
	confluence: <ConfluenceIcon size="small" appearance="brand" />,
	jira: <JiraIcon size="small" appearance="brand" />,
	atlas: <AtlassianIcon label="" size="small" appearance="brand" />,
	// TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
	google_drive: <GoogleDriveIcon label="" />,
	// TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
	microsoft_sharepoint: <MicrosoftSharepointIcon label="" />,
	// TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
	slack: <SlackIcon label="" />,
	// TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
	loom: <LoomIcon label="" />,
};
